import { render, staticRenderFns } from "./DeleteOrderItem.vue?vue&type=template&id=7a01fecb&"
import script from "./DeleteOrderItem.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports